import React from 'react'
import { MASTERMULTICINEMA, MASTERMULTITOTAL } from '../../../constants/multiCinemaModes'
import sortCinemas from '../../../functions/sortCinemas'
import testdata from './test.json'

const CinemaList = ({
    cliCinemas,
    selectionsDisplayItems,
    cliMulticinemaMode,
    clientCinemaId
}) => {
    
    const sortedCinemas = sortCinemas(clientCinemaId, cliCinemas)    
    const showMultiCinemaOptions = cliMulticinemaMode === MASTERMULTICINEMA || cliMulticinemaMode === MASTERMULTITOTAL ? true : false
        
    return showMultiCinemaOptions && sortedCinemas.length > 1 && (
        <div className="cinema-list-selection-counter">
            {sortedCinemas.map((cliCinemaId) => {
                const currentCinema = cliCinemas[cliCinemaId]
                const {nameShort, pk} = currentCinema
                let counter = 0
                _.keys(selectionsDisplayItems).map((selectionsDisplayItemKey) => {
                    const selectionsDisplayItem = selectionsDisplayItems[selectionsDisplayItemKey]
                    const {cinemas, cinemasFilter, visibleIn} = selectionsDisplayItem
                    const cinemasArray = visibleIn ? visibleIn : cinemasFilter ? cinemasFilter : cinemas

                    counter = _.contains(cinemasArray, pk) ? counter + 1 : counter
                })
                
                return (
                    <div className="cinema-list-selection-counter-item" key={pk}>
                        <p className="selection-acronym text-light-description">{nameShort}</p>
                        <p className="selection-counter text-light-description">{counter}</p>
                    </div>
                )
            })} 
        </div>      
    )
}

export default CinemaList